<div fxFlexFill fxLayout="column">


  <span fxLayout="row" class="header">
    <span fxFlex fxLayoutAlign="center center">
      <span dir="auto" class="compliance-status medium" ngClass.xs="compliance-status xs-font medium">{{'covid_19_readiness_matrix' | transloco}}

      </span>
    </span>
    <span style="position: inline;right:0;">
      <a class="close regular" (click)="onNoClick()">{{'close' | transloco}}</a>
    </span>
  </span>
  <mat-dialog-content style="margin-right:0px;">
    <div fxLayout="column" fxLayoutGap="20px" class="div-content" ngClass.xs="div-content-xs">
      <div>
        <img alt="img" [src]="'data:image/jpeg;base64,'+imageSelected" height="100%" width="100%" />
      </div>
      <span dir="auto" class="span-text-status"> {{'if_any_of_the_questions_is_answered_as_not_ready' | transloco}}
      </span>
      <span dir="auto" class="span-title medium">{{'select_readiness_status_by_referring_above_matrix' | transloco}}</span>
      <span fxLayout="row" fxLayoutGap="60px" fxLayoutGap.xs="50px" fxLayoutAlign="start start">

        <span fxLayout="column" style="cursor: pointer;" fxLayoutGap="10px" fxLayoutAlign="center center"
          (click)="onOptionClick('Ready')">
          <img [src]="Green"  class="img-options" />
          <p dir="auto" class="option-text regular">{{'ready' | transloco}}</p>
        </span>
        <span class="span-complaince" fxLayout="column" fxLayoutGap="10px" fxLayoutAlign="center center"
          (click)="onOptionClick('Not Ready')">
          <img [src]="Red"  class="img-options" />
          <p dir="auto" class="option-text regular">{{'not_ready' | transloco}}</p>
        </span>
      </span>
      <span fxLayout="row" fxLayoutGap="20px">
        <span dir="auto" fxFlexAlign="center" class="span-confirm regular">{{'i_confirm_my_answers' | transloco}}</span>
      </span>
      <span fxLayout="column" fxLayoutAlign="center center">
        <button dir="auto" fxFlexAlign="center" mat-flat-button color="primary" class="button-done" ngClass.xs="button-done xs"
          (click)="onDone()" [disabled]="!(complainceStatus && iAgree)">{{'done' | transloco}}</button>
      </span>
    </div>
  </mat-dialog-content>
</div>
